import { Card, CardActionArea, CardContent, CardTypeMap, Typography } from "@mui/material"
import { DefaultComponentProps } from "@mui/material/OverridableComponent"

/**
 * 
 * Cardsimple contain and are surfaces that display content about a single subject.
 * 
 * ###Import to use it
 *
 *```
 *   import { CardSimple } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<CardSimple 
 *   label={string} 
 *   description={string}
 />
 *```
 *
 *### Basic Example
 */

export const CardSimple = (props: CardSimple) => {

    return (
        <Card {...props} className={`card-simple ${props.className}`}>
            <CardActionArea>
                <CardContent>
                    <Typography gutterBottom variant="h6" component="h5">
                        { props.label }
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        { props.description }
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

type CardSimple = DefaultComponentProps<CardTypeMap<{}, "div">> & {
    /** Label */
    label?: string
    /** Description */
    description?: string | React.ReactElement
}
